export default "__VITE_ASSET__CHMpoNn$__"